import { observer } from 'mobx-react';
import React from 'react';

import DrawerLayout from 'components/Views/Creative/Drawers/DrawerLayout';
import store from 'stores/RootStore';
import { PanelViews } from 'types/PanelViews';

import TearsheetSummaryRow from './TearsheetSummaryRow';

function TearsheetsDrawer() {
  const store_creative = store.creative;
  if (!store_creative) return null;

  const handleOnClose = () => {
    store_creative.setPanel(PanelViews.NONE);
  };

  const tearsheets = store_creative.tearsheets.allAvailable;

  return (
    <DrawerLayout
      open={store_creative.displayPanel === PanelViews.TEARSHEETS}
      onClose={handleOnClose}
      title="Tearsheets"
    >
      {tearsheets.map((tearsheet) => (
        <TearsheetSummaryRow key={tearsheet.id} tearsheet={tearsheet} />
      ))}
    </DrawerLayout>
  );
}

export default observer(TearsheetsDrawer);
